import { render, staticRenderFns } from "./DeleteTagKeywordPopUp.vue?vue&type=template&id=ea2ff6a2"
import script from "./DeleteTagKeywordPopUp.vue?vue&type=script&lang=js"
export * from "./DeleteTagKeywordPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports